const mutations = {
  reconstructNav(state, payload) {
    state.navs = [...payload];
  },
};

export default mutations;
